module.exports = __webpack_public_path__ + "img/tables.bbe68f80.svg";